export const Modes = {
  BUILDS: 'builds',
  TRENDS: 'trends',
}
